export const formatToMexicanPesos = (amount: string) => {
  // Aseguramos que la cantidad sea un número
  const numericAmount = parseFloat(amount);

  if (isNaN(numericAmount)) {
    // Si no es un número válido, retornamos un mensaje o el valor original
    return 'Cantidad no válida';
  }

  // Creamos una instancia de Intl.NumberFormat
  const formatter = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN', // Código de divisa para Pesos Mexicanos
    minimumFractionDigits: 2, // Muestra siempre dos decimales
  });

  // Formateamos y retornamos el resultado
  return formatter.format(numericAmount);
};

export function formatearPesoMXN(numero: number) {
  // Asegura que solo tenga 2 decimales sin errores flotantes
  const valorRedondeado = Math.round(numero * 100) / 100;

  const formateador = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formateador.format(valorRedondeado);
}

export const formatFechaMexico = (fechaString: string | Date) => {

  const date = new Date(fechaString);
  if (isNaN(date.getTime())) {
    return 'Fecha inválida'; 
  }

  const option: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'America/Mexico_City',
  };

  return new Intl.DateTimeFormat('es-MX', option).format(date);
};